import { Action, CompanySubject } from '@area-restrita/shared/authorization';

export interface CompanyPermissionCategory {
  category: string;
  subCategories: {
    subCategory: string;
    rules: {
      action: Action;
      subject: CompanySubject;
      label: string;
      description: string;
    }[];
  }[];
}

export const companyPermissionCategories: CompanyPermissionCategory[] = [
  {
    category: 'Empresa',
    subCategories: [
      {
        subCategory: 'Empresa',
        rules: [
          {
            action: 'viewDetails',
            subject: 'company',
            label: 'Visualizar detalhes da empresa',
            description:
              'Permite visualizar os detalhes da empresa, como nome, CNPJ, endereço e outras informações relevantes.',
          },
        ],
      },
      {
        subCategory: 'Membros da empresa',
        rules: [
          {
            action: 'list',
            subject: 'company_memberships',
            label: 'Listar membros da empresa',
            description:
              'Permite listar todos os membros da empresa, incluindo suas funções e status de associação.',
          },
          {
            action: 'create',
            subject: 'company_memberships',
            label: 'Criar membro da empresa',
            description:
              'Permite adicionar novos membros à empresa, atribuindo-lhes funções e permissões específicas.',
          },
          {
            action: 'update',
            subject: 'company_memberships',
            label: 'Atualizar membro da empresa',
            description:
              'Permite atualizar as informações de um membro da empresa, como função, status e outras configurações.',
          },
          {
            action: 'delete',
            subject: 'company_memberships',
            label: 'Excluir membro da empresa',
            description:
              'Permite remover um membro da empresa, excluindo suas associações e permissões.',
          },
        ],
      },
      {
        subCategory: 'Departamentos',
        rules: [
          {
            action: 'list',
            subject: 'departments',
            label: 'Listar departamentos',
            description:
              'Permite visualizar todos os departamentos da empresa, incluindo suas funções e membros.',
          },
          {
            action: 'viewDetails',
            subject: 'departments',
            label: 'Visualizar detalhes do departamento',
            description:
              'Permite visualizar os detalhes de um departamento específico, incluindo nome, descrição e membros associados.',
          },
        ],
      },
    ],
  },
  {
    category: 'Documentos',
    subCategories: [
      {
        subCategory: 'Categorias de Documentos',
        rules: [
          {
            action: 'list',
            subject: 'document_categories',
            label: 'Listar categorias de documentos',
            description:
              'Permite visualizar a lista de categorias de documentos',
          },
          {
            action: 'viewDetails',
            subject: 'document_categories',
            label: 'Ver detalhes de categorias',
            description:
              'Permite visualizar detalhes de categorias de documentos',
          },
        ],
      },
      {
        subCategory: 'Documentos',
        rules: [
          {
            action: 'list',
            subject: 'documents',
            label: 'Listar documentos',
            description: 'Permite visualizar a lista de documentos',
          },
          {
            action: 'viewDetails',
            subject: 'documents',
            label: 'Ver detalhes de documentos',
            description: 'Permite visualizar detalhes completos de documentos',
          },
        ],
      },
      {
        subCategory: 'Solicitações de Documentos',
        rules: [
          {
            action: 'list',
            subject: 'document_requests',
            label: 'Listar solicitações de documentos',
            description:
              'Permite visualizar a lista de solicitações de documentos',
          },
          {
            action: 'viewDetails',
            subject: 'document_requests',
            label: 'Ver detalhes de solicitações',
            description:
              'Permite visualizar detalhes de solicitações de documentos',
          },
          {
            action: 'create',
            subject: 'document_requests',
            label: 'Criar solicitações',
            description: 'Permite criar novas solicitações de documentos',
          },
          {
            action: 'update',
            subject: 'document_requests',
            label: 'Atualizar solicitações',
            description: 'Permite editar solicitações de documentos existentes',
          },
        ],
      },
    ],
  },
  {
    category: 'Linhas de Ônibus',
    subCategories: [
      {
        subCategory: 'Linhas e Horários',
        rules: [
          {
            action: 'list',
            subject: 'busline_schedules',
            label: 'Listar linhas e horários de ônibus',
            description:
              'Permite visualizar a lista de linhas de ônibus e seus horários associados.',
          },
          {
            action: 'viewDetails',
            subject: 'busline_schedules',
            label: 'Ver detalhes de linhas e horários',
            description:
              'Permite visualizar detalhes específicos de uma linha de ônibus, incluindo horários e paradas.',
          },
        ],
      },
    ],
  },
  {
    category: 'NPS',
    subCategories: [
      {
        subCategory: 'Campanhas NPS',
        rules: [
          {
            action: 'list',
            subject: 'nps',
            label: 'Listar campanhas NPS',
            description:
              'Permite visualizar a lista de campanhas NPS disponíveis para a empresa.',
          },
          {
            action: 'viewDetails',
            subject: 'nps',
            label: 'Ver métricas NPS',
            description:
              'Permite visualizar métricas de campanhas NPS quando a campanha liberar métricas para a empresa.',
          },
          {
            action: 'viewComments',
            subject: 'nps',
            label: 'Visualizar comentários NPS',
            description:
              'Permite visualizar comentários de campanhas NPS quando a campanha liberar comentários para a empresa.',
          },
          {
            action: 'export',
            subject: 'nps',
            label: 'Exportar resultados NPS',
            description:
              'Permite exportar resultados de campanhas NPS quando a campanha liberar exportação para a empresa.',
          },
        ],
      },
    ],
  },
];
